export default {
  GET_FRIENDS_UPDATES(state, payload) {
    state.friendsUpdates = payload;
  },
  SELECT_FRIENDS_UPDATES(state, payload) {
    state.selectedfriendsUpdates = payload;
  },
};
